var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:[
    `btn-${_vm.color}`,
    {
      'btn-small': _vm.small,
      'btn-ghost': _vm.ghost,
      blank: _vm.blank,
      inline: _vm.inline,
      icon: _vm.icon,
      borderless: _vm.borderless,
      disabled: _vm.disabled,
      hovergrow: _vm.hovergrow,
      'btn-stayactive': _vm.stayActive,
      bigicon: _vm.bigicon
    }
  ],attrs:{"type":_vm.type},on:{"click":_vm.callback}},[_vm._t("icon"),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }